import React from 'react';
import { Link, useHistory } from 'react-router-dom';
import { PurchaseOrderRow } from '../../utils/axios';

export const OnePurchaseOrderRow: React.FC<PurchaseOrderRow> = (props) => {
  const history = useHistory();
  return (
    <tr
      className="orderRow"
      onClick={() => {
        history.push(`/incoming/${props._id}`, { from: '/' });
      }}
    >
      <td>
        <h5 className="m-0">
          <strong>{props._id}</strong>
          <br />
        </h5>
      </td>
      <td>
        <h5 className="m-0">
          <strong>{props.salesOrderId}</strong>
          <br />
        </h5>
      </td>
      <td>
        <h5 className="m-0">
          <strong>{props.vendorId}</strong>
          <br />
        </h5>
      </td>
      <td>
        <strong>{new Date(props.createdAt).toLocaleDateString()}</strong>
      </td>
      <td>
        <div
          className={`OrderStatus ${
            props.status === 'PROCESSING' ? 'Blue' : 'Green'
          }`}
        >
          <h6 className="mb-0">{props.status}</h6>
        </div>
      </td>
    </tr>
  );
};
